import Div from "../Div";
import Input from "../Input";
import FormButton from "../FormButton";
import { createPortal } from "react-dom";
import Form from "../Form";
import { getAllAximaProducts, updateAximaDomain, getAximaSubscriptionDetail } from '../../http/aximaHttp/AximaDomainHttp'
import { axima_billing_frequency } from "../../util/enum";
import Select from "../Select";
import { useEffect, useState, useCallback } from "react";
import { deployment_status } from "../../util/enum";
import { role } from "../../util/validation";

export default function EditDomainModal({ updateState, domain_name, handleClicked, ...props }) {

    const [inputDomain, setInputDomain] = useState({
        ticket_number: '',
        customer_name: '',
        customer_email: '',
        company_name: '',
        domain_name: '',
        tenant_name: '',
        user_count: '',
        product: '',
        comments: '',
        order_id: '',
        start_date: '',
        renewal_date: '',
        requested_by: '',
        field_distributor: '',
        billing_frequency: '',
        customer_phone: ''
    })

    const [product, setProduct] = useState()
    const [renewalDate, setRenewalDate] = useState('')

    const getDomains = useCallback(async () => {

        const response = await getAximaSubscriptionDetail(domain_name.subscription_id)
        console.log(response)
        setInputDomain({
            ticket_number: response?.domains[0]?.ticket_number,
            customer_name: response?.domains[0]?.name,
            customer_email: response?.domains[0]?.email,
            company_name: response?.domains[0]?.companyName,
            tenant_name: response?.domains[0]?.tenant_name,
            user_count: response?.domains[0]?.user_count,
            comments: response?.domains[0]?.comments,
            product: response?.domains[0]?.axima_product_name,
            order_id: response?.domains[0]?.order_id,
            start_date: response?.domains[0]?.start_date,
            renewal_date: response?.domains[0]?.renewal_date,
            requested_by: response?.domains[0]?.requested_by,
            field_distributor: response?.domains[0]?.field_distributor,
            billing_frequency: response?.domains[0]?.billing_frequency,
            customer_phone: response?.domains[0]?.phoneNumber
        })
        // setInitialDomainList(response.domains)
    }, [domain_name.subscription_id])

    const status = deployment_status.deployment_status.map((status) =>
        <option key={status.id}
            name={status.id}
            value={status.id}>
            {status.value}</option>
    )

    const getAximaProducts = async () => {
        const response = await getAllAximaProducts()
        const products = response?.products.map((product) =>
            <option key={product.ap_id}
                name={product.ap_id}
                value={product.ap_id}>
                {product.axima_product_name}</option>)

        setProduct(products)
    }

    useEffect(() => {
        getAximaProducts()
        getDomains()
    }, [getDomains])

    function handleClose() {
        handleClicked(false);
    }

    const comments_status = axima_billing_frequency.billing_frequency.map((frequency) =>
        frequency.id !== axima_billing_frequency ?
            <option key={frequency.id}
                name={frequency.id}
                value={frequency.value}>
                {frequency.value}</option>
            : null);

    function handleStartDateChange(e){
        console.log(e.target.value)
        setInputDomain((prev) => ({ ...prev, start_date: e.target.value }))
        const newRenewalDate = new Date();
        if (inputDomain.billing_frequency === 'Monthly Monthly'){
            newRenewalDate.setDate(newRenewalDate.getDate() + 30);
            console.log(newRenewalDate.toISOString().split('T')[0])
            setRenewalDate(newRenewalDate.toISOString().split('T')[0])
    
        }
        else{
            newRenewalDate.setDate(newRenewalDate.getDate() + 365);
            console.log(newRenewalDate.toISOString().split('T')[0])
            setRenewalDate(newRenewalDate.toISOString().split('T')[0])
    
        }

     }

    async function handleUpdateStatus(event) {
        event.preventDefault();
        const statusFD = new FormData(event.target)

        const data = Object.fromEntries(statusFD.entries())
        // if ((!data.domain_status)) {

        //     handleClicked(false)
        // }
        // else {
        const response = await updateAximaDomain(data, domain_name.subscription_id, role, renewalDate)
        // console.log(response)
        // if (!response.error) {
        //     //     handleClicked(false)
        //     //     updateState()
        //     // }
        //     // else {
        //     //     alert(response.message)
        //     // }
        // }

    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', maxWidth: '85%' }}>

                        <Div className="form-group">
                            Edit Domain {domain_name.domain_name}
                        </Div>
                        <Div className='scroll-container'
                            style={{
                                overflowY: "auto",
                                height: "604px",
                                width: "100%",
                                border: "1px solid #000",
                                padding: "10px",
                            }}>
                            <Form onSubmit={handleUpdateStatus}>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Ticket Number</label>
                                    <Input text='' name="ticket_number" type="text" className="form-control"
                                        placeholder="Enter Ticket No." value={inputDomain.ticket_number} disabled />
                                </Div>

                                {/* <Div className="form-group">
                                <label style={{ fontSize: 'smaller' }}>Domain Name</label>
                                <Input text='' name="domain_name" value={domain_name.domain_name} disabled
                                    type="text" className="form-control" placeholder="Enter Domain Name" />
                            </Div> */}

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Customer Email</label>
                                    <Input text='' name="customer_email" type="email" className="form-control" disabled
                                        placeholder="Enter Customer Name" value={inputDomain.customer_email} />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Customer Name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, customer_name: e.target.value }))} name="customer_name"
                                        type="text" className="form-control" placeholder="Enter Customer Name" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.customer_name} />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Customer Phone Number</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, customer_phone: e.target.value }))} name="phone_number"
                                        type="text" className="form-control" placeholder="Enter Phone Number" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.customer_phone} />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Company Name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, company_name: e.target.value }))} name="company_name"
                                        type="text" className="form-control" placeholder="Enter Company Name" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.company_name} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Tenant name</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, tenant_name: e.target.value }))} name='tenant_name'
                                        type="text" className="form-control" placeholder="Enter Tenant Name" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.tenant_name} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>User Count</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, user_count: e.target.value }))} name='user_count'
                                        type="text" className="form-control" placeholder="Enter User Count" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.user_count} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Products</label>
                                    <Select text='' options={product} defaultValue={inputDomain.product} disabled={role === 'ADEPLOY' ? true : false}
                                        className="form-control" name='product'
                                    />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Comments</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, comments: e.target.value }))} name='comments'
                                        type="text" className="form-control" placeholder="Enter Comments" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.comments} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Order Id</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, order_id: e.target.value }))} name='order_id'
                                        type="text" className="form-control" placeholder="Enter Order Id" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.order_id} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Start Date</label>
                                    <Input text='' onChange={(e) => handleStartDateChange(e)} name='start_date'
                                        type="date" className="form-control" placeholder="Enter Start Date" disabled={role === 'SALESC' ? true : false}
                                        value={inputDomain.start_date} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Renewal Date</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, renewal_date: e.target.value }))} name='renewal_date'
                                        type="date" className="form-control" placeholder="Enter End Date/ Renewal Date" disabled
                                        value={inputDomain.renewal_date? inputDomain.renewal_date : renewalDate} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Request By</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, requested_by: e.target.value }))} name='requested_by'
                                        type="text" className="form-control" placeholder="Enter Requested By" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.requested_by} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Field Distributor</label>
                                    <Input text='' onChange={(e) => setInputDomain((prev) => ({ ...prev, field_distributor: e.target.value }))} name='field_distributor'
                                        type="text" className="form-control" placeholder="Enter New Field Distributor" disabled={role === 'ADEPLOY' ? true : false}
                                        value={inputDomain.field_distributor} />
                                </Div>
                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Billing Frequency</label>
                                    <Select text='' options={comments_status} defaultValue={inputDomain.billing_frequency} disabled={role === 'ADEPLOY' ? true : false}
                                        className="form-control" name='billing_frequency' />
                                </Div>

                                <Div className="form-group">
                                    <label style={{ fontSize: 'smaller' }}>Subscription Status</label>
                                    <Select name='status' options={status} defaultValue="Select Status" disabled={role === 'ADEPLOY' ? false : true}
                                    // onChange={(e) => handleUpdateSegmentSelect(e.target.value)}
                                    />

                                </Div>

                                <Div className="form-group">
                                    <Div className='row'>
                                        <Div className='col-sm-6'>
                                            <FormButton type='submit' style={{ margin: '2px' }}
                                                className="btn btn-primary submit-btn btn-block">Add Domain</FormButton>
                                        </Div>
                                        <Div className='col-sm-6'>
                                            <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                        </Div>
                                    </Div>

                                    <Div className='row'>
                                        <Div className='col-sm-12'>
                                            {/* {error ? <p style={{ color: 'red', marginLeft: '15px', marginTop: '4px' }}> {error}</p> : null} */}
                                        </Div>
                                    </Div>
                                </Div>
                            </Form>
                        </Div>
                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )

}